<input-wrap
  label="{{ 'translate.mng.note' | translate }}"
  cssClass="l-cell-spread w-full"
>
  <textarea class="t-input t-input--colored" [(ngModel)]="note"></textarea>
</input-wrap>
